// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-LogoLink-module--cls1--2NTA9","cls2":"styles-LogoLink-module--cls2--tb5lu styles-LogoLink-module--cls1--2NTA9"};